(function () {
  var SECTION_SELECTOR = '[data-oc-mr-top-hosts]';

  function toInt(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? fallback : parsed;
  }

  function initSwiper(sectionElement) {
    if (sectionElement.dataset.ocMrTopHostsInit === 'true') {
      return true;
    }

    var swiperElement = sectionElement.querySelector('[data-hosts-swiper]');
    if (!swiperElement || typeof Swiper === 'undefined') {
      return false;
    }

    var slideCount = toInt(sectionElement.dataset.slideCount, 0);
    var showDesktopNav = slideCount > 3;
    var nextButton = sectionElement.querySelector('[data-nav-next]');
    var prevButton = sectionElement.querySelector('[data-nav-prev]');
    var paginationEl = sectionElement.querySelector('[data-hosts-pagination]');

    var swiper = new Swiper(swiperElement, {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      loop: false,
      speed: 450,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      allowTouchMove: slideCount > 1,
      navigation: showDesktopNav
        ? {
            nextEl: nextButton,
            prevEl: prevButton,
          }
        : undefined,
      pagination:
        paginationEl && slideCount > 1
          ? {
              el: paginationEl,
              clickable: true,
            }
          : undefined,
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 10,
          allowTouchMove: slideCount > 1,
        },
        769: {
          slidesPerView: Math.min(3, Math.max(slideCount, 1)),
          spaceBetween: 30,
          allowTouchMove: showDesktopNav,
        },
      },
    });

    sectionElement._ocMrTopHostsSwiper = swiper;
    sectionElement.dataset.ocMrTopHostsInit = 'true';
    return true;
  }

  function initSection(sectionElement) {
    if (!initSwiper(sectionElement)) {
      window.setTimeout(function () {
        initSwiper(sectionElement);
      }, 300);
    }
  }

  function destroySection(sectionElement) {
    if (!sectionElement) return;

    if (sectionElement._ocMrTopHostsSwiper) {
      sectionElement._ocMrTopHostsSwiper.destroy(true, true);
      delete sectionElement._ocMrTopHostsSwiper;
    }
    delete sectionElement.dataset.ocMrTopHostsInit;
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionElement = event.target.querySelector(SECTION_SELECTOR);
    destroySection(sectionElement);
  });
})();
